import HeaderFooterLayout from 'layouts/HeaderFooterLayoutNew';
import React from 'react';
import CancelMembership from 'components/HomePageNew/CancelMembership';

const CancelMembershipPage = ({ ...props }) => {
  return (
    <div>
      <HeaderFooterLayout>
        <CancelMembership {...props} />
      </HeaderFooterLayout>
    </div>
  );
};

export default CancelMembershipPage;
